import {
  BreadcrumbsProps as MantineBreadcrumbsProps,
  Breadcrumbs as MantineBreadcrumbs,
} from '@mantine/core';

export type BreadcrumbsProps = MantineBreadcrumbsProps;

export const Breadcrumbs = MantineBreadcrumbs;

Breadcrumbs.displayName = 'Breadcrumbs';
